// locale-unextracted-ignore-file
import { CustomScreenDownloadMediaTabCompletedToast } from '@app/components/custom-screen/CustomScreenDownloadMediaTabCompletedToast';
import {
  DownloadMediaNotificationErrorView,
  DownloadMediaNotificationLoadingView,
  DownloadMediaNotificationPendingView,
} from '@app/modules/logger/screens/stream/features/download-media/NotificationViews';
import { AuditReportsPublicJobDto, AuditReportsPublicJobDtoStatusEnum } from '@mi-front/api-v2';
import { Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { toast } from 'react-toastify';

const MOCK_JOB_PENDING: AuditReportsPublicJobDto = {
  id: 'demo-pending',
  status: AuditReportsPublicJobDtoStatusEnum.IN_PROGRESS,
  progressPercent: 45,
  processedOn: new Date().toISOString(),
  isPending: true,
  isFinished: false,
};

/**
 * Shows a notification (toast) with the given React node as content, same pattern as useDownloadMedia.
 */
function showNotificationView(content: React.ReactNode) {
  const toastId = toast.info('', { autoClose: false, icon: false });
  toast.update(toastId, {
    render: content,
    icon: false,
  });
}

/**
 * Tab content for the Custom Screen download media notification views demo.
 * Each button shows the corresponding view as a real toast notification.
 */
export function CustomScreenDownloadMediaTab() {
  const showLoading = () => {
    showNotificationView(<DownloadMediaNotificationLoadingView />);
  };

  const showError = () => {
    showNotificationView(<DownloadMediaNotificationErrorView />);
  };

  const showPending = () => {
    showNotificationView(<DownloadMediaNotificationPendingView job={MOCK_JOB_PENDING} />);
  };

  const showCompleted = () => {
    const toastId = toast.info('', { autoClose: false, icon: false });
    toast.update(toastId, {
      render: <CustomScreenDownloadMediaTabCompletedToast toastId={toastId} />,
      icon: false,
    });
  };

  return (
    <Stack spacing={3}>
      <Typography variant="subtitle2" color="text.secondary">
        Demo de cada vista de notificación de descarga de media
      </Typography>
      <Stack direction="row" flexWrap="wrap" gap={2}>
        <Button variant="outlined" size="small" onClick={showLoading}>
          Mostrar LoadingView
        </Button>
        <Button variant="outlined" size="small" onClick={showError}>
          Mostrar ErrorView
        </Button>
        <Button variant="outlined" size="small" onClick={showPending}>
          Mostrar PendingView
        </Button>
        <Button variant="outlined" size="small" onClick={showCompleted}>
          Mostrar CompletedView
        </Button>
      </Stack>
    </Stack>
  );
}
